import React from 'react';
import classes from './block3.module.css';
import img1 from './images/img.png';
import img2 from './images/img_1.png';
import img3 from './images/img_2.png';

const Block3 = () => {
    return (
        <div className={classes._}>
            <img src={img1} alt="img1" className={classes.img1} />
            <img src={img2} alt={''} className={classes.img2} />
            <img src={img3} alt={''} className={classes.img3} />
            <div className={classes.block}>
                <div className={classes.text1}>с 23.10.2025 по 31.03.2026</div>
                <div className={classes.text2}>Консультация бесплатно</div>
                <div className={classes.text3}>Подбор стрижки<br/>Рекомендации по уходу<br/>Исправление неудачных стрижек<br/>Создание программы для достижения желаемого эффекта!</div>
            </div>
        </div>
    );
};

export default Block3;